export const KwanMobileThree = () => {
    return (
        <div className="px-[32px] py-[13px] [background:linear-gradient(180deg,rgba(255,255,255,1)_0%,rgba(247.94,246.21,255,1)_34.135%,rgba(232.12,243.25,255,1)_66.346%,rgba(255,255,255,1)_100%)]">
            <div className="flex justify-center"><div className="text-[22px] font-bold text-[rgba(51,51,51,1)]">我们可以做什么</div></div>
            <div className="flex justify-center"><div className="text-[8px] font-regular text-[rgba(119,119,119,1)] mt-[10px]">企业出海多场景网络支持</div></div>
            <div className="flex justify-center"><div className="text-[12px] font-regular text-[rgba(15,43,91,1)] mt-[22px]">企业出海办公网络加速</div></div>
            <div className="flex justify-center mt-[10px]">
                <div className="text-[10px] font-regular text-[rgba(51,51,51,1)]">
                    访问国内或国外办公需求场景的网络加速服务，企业办公、海外SaaS应用、企业海外推广、品牌宣传，异地传输，不同办公点的跨国际互通互访。提供企业后台管理系统，可以根据公司架构针对部门分类管理，线路调度分配、IP定制化服务，自定义设置访问IP黑白名单功能等。并且支持轻松满足千人团队同时在线使用。
                </div>
            </div>
            <div className="flex justify-center mt-[20px]">
                <div className="text-[12px] text-[#FFFFFF] font-medium text-center w-[72px] h-[24px] flex flex-row justify-center items-center  py-[4px] rounded-[3.84px] [background:linear-gradient(135deg,rgba(94.81,150.87,255,1)_0%,rgba(1,130,255,1)_100%)]">
                    查看详情
                </div>
            </div>
            <div className="grid grid-cols-2 gap-[22px] mt-[15px]">
                <img src="/imgs/kwan/3-1.png" className="w-[149px] h-[88px]" />
                <img src="/imgs/kwan/3-2.png" className="w-[149px] h-[88px]" />
                <img src="/imgs/kwan/3-3.png" className="w-[149px] h-[88px]" />
                <img src="/imgs/kwan/3-4.png" className="w-[149px] h-[88px]" />
                <img src="/imgs/kwan/3-5.png" className="w-[149px] h-[88px]" />
                <img src="/imgs/kwan/3-6.png" className="w-[149px] h-[88px]" />
            </div>

            <div className="mt-[25px] flex justify-center"><div className="text-[22px] font-bold text-[rgba(51,51,51,1)]">我们的全球骨干网络</div></div>
            <div className="flex justify-center mt-[10px]">
                <div className="text-[10px] font-regular text-[rgba(51,51,51,1)] text-center">
                    采用全自研K-WAN组网系统，网络资源覆盖全球180多个国家与地区，可以让企业接入加速网路，快速访问!工作效率倍升!
                </div>
            </div>
            <img src="/imgs/kwan/global.png" className="w-[100%] mt-[15px]" />
            <div className="mt-[25px] flex justify-center"><div className="text-[22px] font-bold text-[rgba(51,51,51,1)]">光年K-WAN全球网络加速原理</div></div>
            <img
                src="/imgs/kwan/principle.png"
                className="w-[100%] h-[240px] mt-[15px]"
            />
        </div>
    );
};